export const requestTypes = {
  REMOVE_PARCEL: "RP",
  ADD_PARCEL: "AP",
  LOAD_PARCEL: "LP",
  REMOVE_COLLECTION: "RC",
  ADD_COLLECTION: "AC",
  AMEND_PICKUP_PARCELS: "PK",
  HEART_BEAT: "HB",
  ADDRESS_MODIFY: "AM",
  DEPARTED: "AU",
};

export const removalRequestTypes = [
  requestTypes.REMOVE_COLLECTION,
  requestTypes.REMOVE_PARCEL,
  requestTypes.AMEND_PICKUP_PARCELS,
];

export const addRequestTypes = [
  requestTypes.ADD_COLLECTION,
  requestTypes.ADD_PARCEL,
];

export const responseTypes = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  DEFER: "Defer",
};

export const requestIconType = {
  ADD: "add",
  DEFFER: "defer",
  REMOVE: "remove",
  MIXED: "mixed",
};

export const DRIVER_REQUEST_TYPE = {
  COLLECTION: "collection",
  PICKUP: "pickup",
  DELIVERY: "delivery",
};

export const requestOriginTypes = {
  ROUTE_PLANNER: "F",
  SATURN: "S",
};
